import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from "@angular/router";
import { ContentService } from 'src/app/services/content.service';
import { StateService } from 'src/app/services/state.service';
import { ConfigService } from 'src/app/services/config.service';
import { LangService } from 'src/app/services/lang.service';
import { environment } from 'src/environments/environment';
import { EncryptionService } from 'src/app/services/encryption.service';
import { filter } from 'rxjs/operators';
import { LoginService } from "../../services/login.service";
import { LogoutService } from "src/app/services/logout.service";
import { firstValueFrom } from 'rxjs';
import { RevokeTokenService } from "src/app/services/revoke-token.service";
import { Offcanvas } from 'bootstrap';
import { Browser } from '@capacitor/browser';
import { App } from '@capacitor/app';
import { Preferences } from '@capacitor/preferences';
import { Capacitor } from '@capacitor/core';
import { AppVersionService } from 'src/app/services/app-version.service';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { EnviromentStateComponent } from "../enviroment-state/enviroment-state.component";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        EnviromentStateComponent
    ]
})
export class HeaderComponent implements OnInit {

  codeVerifier: string = "";
  code: string = "";
  accessToken: string = "";
  refreshToken: string = "";
  dataLoaded: boolean = false;
  isIos: boolean = false;
  isAndroid: boolean = false;

  canAccess: string | null = null;
  public logoHeader: string = ''
  public logoOffCanvas: string = ''
  public privateMode: boolean = false
  public lang: string;
  public currentUrl: string = '';
  private customerId: number = 0;
  public isNative: boolean = false;
  public appVersion$!: Observable<string>;

  constructor(private contentService: ContentService,
              private stateService: StateService,
              public configService: ConfigService,
              private langService: LangService,
              public router: Router,
              private encryptionService: EncryptionService,
              private cdr: ChangeDetectorRef,
              private loginService: LoginService,
              private activatedRoute: ActivatedRoute,
              private logoutService: LogoutService,
              private revokeTokenService: RevokeTokenService,
              private appVersionService: AppVersionService
            ) 
  { 
    this.lang = langService.getLanguage()!;
    this.appVersion$ = this.appVersionService.version$;
  }

  ngOnInit(): void {
    this.isIos = /iPad|iPhone|iPod/.test(navigator.userAgent);
    this.isAndroid = /Android/.test(navigator.userAgent);
    this.isNative = Capacitor.isNativePlatform();
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['code']) {
        this.handleAuthCallback(window.location.href);
      } else if (params['requireAuth'] === 'true') {
        this.logIn();
      }
    });

    // Area privada
    if (sessionStorage.getItem('tokenLogIn')) {
      this.privateMode = true;
      this.loadLogos();
    }else {
      this.privateMode = false;
    }


    // Escuchar cambios en la URL
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      setTimeout(() => {
        this.currentUrl = event.url;
      });
    });

    // Inicializar el valor de la URL actual
    this.currentUrl = this.router.url;

    App.addListener('appUrlOpen', async (event: any) => {
      if (event.url && event.url.startsWith('app://callback')) {
        try {
          await Browser.close(); // Intentamos cerrar solo si está abierto
        } catch (error) {
          
        }
        this.handleAuthCallback(event.url);
      }
    });
  }

  handleAuthCallback(url: string): void {
    const urlParams = new URLSearchParams(url.split('?')[1]);
    const authCode = urlParams.get('code');
    if (authCode) {
      this.code = authCode;
      this.callBackToken();
    }
  }

  changeTab( link: string ) {
    this.router.navigate([link]);
  }

  // Verifica si la URL actual coincide con la ruta del enlace.
  //Se puede recibir un array de rutas para asociar un menú activado con más de una ruta
  isActive(route: string | string[]): boolean {
    if (Array.isArray(route)) {
      // Si es un array, comprueba si alguna ruta coincide
      return route.some(r => this.currentUrl === r || this.currentUrl === r + '/');
    } else {
      // Si es una cadena, mantén la lógica original
      return this.currentUrl === route || this.currentUrl === route + '/';
    }
  }

  loadLogos(): void {

        //Suscripción al observable 'NavbarPrivateObservable' que informa cada componente del router indicando si debe mostrar
    //cabecera private o pública.
    this.stateService.NavbarPrivateObservable
    .subscribe({
        next: (data) => {
          if(this.privateMode){

            this.contentService.getPrivateContent().subscribe((data) => {
              const foundHeader = data.find((obj: { content: { location: { id: any; }; }; }) => obj.content.location.id === this.configService.companyConfig.logo.header);
              const foundOffCanvas = data.find((obj: { content: { location: { id: any; }; }; }) => obj.content.location.id === this.configService.companyConfig.logo.offcanvas);
              this.logoHeader = foundHeader?.content?.images?.[this.lang]?.web?.[0]?.url || 'https://inloyalty.s3.eu-west-1.amazonaws.com/malaga-no-caduca/images/logos/logo-text-mixto.png';
              this.logoOffCanvas = foundOffCanvas?.content?.images?.[this.lang]?.web?.[0]?.url || 'https://inloyalty.s3.eu-west-1.amazonaws.com/malaga-no-caduca/images/logos/logo-text-mixto.png';
              this.cdr.detectChanges();
            });
            
          }else{

            this.contentService.getPublicContent().subscribe((data) => {
              const foundHeader = data.find((obj: { content: { location: { id: any; }; }; }) => obj.content.location.id === this.configService.companyConfig.logo.header);
              const foundOffCanvas = data.find((obj: { content: { location: { id: any; }; }; }) => obj.content.location.id === this.configService.companyConfig.logo.offcanvas);
              this.logoHeader = foundHeader?.content?.images?.[this.lang]?.web?.[0]?.url || 'https://inloyalty.s3.eu-west-1.amazonaws.com/malaga-no-caduca/images/logos/logo-text-mixto.png';
              this.logoOffCanvas = foundOffCanvas?.content?.images?.[this.lang]?.web?.[0]?.url || 'https://inloyalty.s3.eu-west-1.amazonaws.com/malaga-no-caduca/images/logos/logo-text-mixto.png';
              this.cdr.detectChanges();
            });
          }
        },
        error: (error) => {}
    })

  }

  // Proceso de login keyCloak

  generateCodeVerifier(): string {
    const array = new Uint8Array(43);
    window.crypto.getRandomValues(array);
    return btoa(String.fromCharCode.apply(null, Array.from(array)))
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '');
  }

  async generateCodeChallenge(codeVerifier: string): Promise<string> {
    const encoder = new TextEncoder();
    const data = encoder.encode(codeVerifier);
    const hash = await window.crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hash));
    return btoa(String.fromCharCode.apply(null, hashArray))
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '');
  }


  async logIn() {
    const API_URL = `${environment.keycloakUrl}/realms/${environment.keycloakRealm}`;
    const url: string = `${API_URL}/protocol/openid-connect/auth`;

    this.codeVerifier = this.generateCodeVerifier();
    const isMobile = (window as any).Capacitor?.isNativePlatform?.() ?? false;
    const redirectUri = isMobile ? "app://callback" : window.location.origin + "/home";
    const codeChallenge = await this.generateCodeChallenge(this.codeVerifier);

    if (this.isIos) {
      await Preferences.set({ key: 'codeVerify', value: this.codeVerifier });
      await Preferences.set({ key: 'redirectUri', value: redirectUri });
    } else {
      sessionStorage.setItem('codeVerify', this.codeVerifier);
      sessionStorage.setItem('redirectUri', redirectUri);
    }

    let authorizationUrl = url + "?";
    authorizationUrl += "response_type=code&";
    authorizationUrl += "client_id=" + environment.keycloakClientId + "&";
    authorizationUrl += "redirect_uri=" + encodeURIComponent(redirectUri) + "&";
    authorizationUrl += "code_challenge_method=S256&";
    authorizationUrl += "code_challenge=" + codeChallenge;

    await Browser.open({ url: authorizationUrl, windowName: "_self" });
  }

  async callBackToken() {
    const currentUrl = window.location.origin;
    let codeVerifier: string | null = null;
    let redirectUri: string | null = null;

    if (this.isIos) {
      const result = await Preferences.get({ key: 'codeVerify' });
      codeVerifier = result.value;

      const redirectResult = await Preferences.get({ key: 'redirectUri' });
      redirectUri = redirectResult.value;
    } else {
      codeVerifier = sessionStorage.getItem('codeVerify');
      redirectUri = sessionStorage.getItem('redirectUri');
    }

    const data = {
      code: this.code,
      grant_type: "authorization_code",
      client_id: environment.keycloakClientId,
      redirect_uri: redirectUri,
      code_verifier: codeVerifier
    };

    const body = this.convertToQueryString(data);
    this.loginService.obtainToken(body).subscribe({
      next: (response) => {
        this.accessToken = response.access_token;
        this.refreshToken = response.refresh_token;
        sessionStorage.setItem('tokenLogIn', this.accessToken);
        sessionStorage.setItem('refreshLogIn', this.refreshToken);
        this.privateMode = true;
        
        const intendedRoute = sessionStorage.getItem('intendedRoute');
        if (intendedRoute) {
          sessionStorage.removeItem('intendedRoute');
          this.router.navigate([intendedRoute]);
        } else {
          this.router.navigate(['/auth-home']);
        }
      },
      error: (error) => {
        console.error("Error al obtener token", error);
        this.privateMode = false;
      }
    });
    try {
      await Browser.close();
    } catch (error) {
    }
  }

  convertToQueryString(data: any): string {
    return Object.keys(data)
      .map(key => `${key}=${encodeURIComponent(data[key])}`)
      .join('&');
  }

  async revokeToken() {
    return firstValueFrom(this.revokeTokenService.revokeToken());
  }

  async logOut() {
    this.logoutService.logOut();
    this.privateMode = false;
  }

  openNavbar(): void {
    const offcanvasEl = document.getElementById('navbarNav');
    if (offcanvasEl) {
      const instance = new Offcanvas(offcanvasEl, {
        backdrop: true,
        scroll: true
      });
      instance.show();
    }
  }

}